import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFunctions } from "firebase/functions";
const firebaseConfig = {
  apiKey: "AIzaSyBVOWRGhuzs_luREEcK11OFO6yGBIQxdTw",
  authDomain: "skilll-dev.firebaseapp.com",
  projectId: "skilll-dev",
  storageBucket: "skilll-dev.firebasestorage.app",
  messagingSenderId: "491805924882",
  appId: "1:491805924882:web:fdb1d347a9af05a73e82cb",
  measurementId: "G-TQQ4SRJ75R",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const functions = getFunctions(app);
